export default "__VITE_ASSET__Cj7BnluQ__"